<template>
  <div class="history_home">
    <div class="nav_con">
      <span @click="$router.push('/')" class="home_tab">首页</span>
      <
      <span @click="$router.push('/pcpage_history/history_home')" style="cursor: pointer">往期回顾</span>
    </div>
    <time-nav @changeYear="changeYear"></time-nav>
    <div class="work_wrap"  v-if="workData.video.length">
      <img src="../../img/vlog_head.png" alt="" class="work_title">
      <div class="work_con clearfix">
        <img src="../../img/triangle.png" alt="" class="triangle">
        <div class="clearfix" v-if="workData.video.length">
          <div class="first_work" @click="goDetail(workData.video[0])">
            <img :src="'https://collection2021-cos.chineseplus.net/'+workData.video[0].video_cover" alt="">
          </div>
          <ul class="work_list">
            <li v-for="(v, i) in workData.video.slice(1)" :key="i" @click="goDetail(v)">
              <img :src="'https://collection2021-cos.chineseplus.net/'+v.video_cover" alt="">
            </li>
          </ul>
        </div>
        <div class="more" @click="goList(1)">
          查看更多
        </div>
      </div>
    </div>

    <div class="work_wrap">
      <img src="../../img/plog_head.png" alt="" class="work_title">
      <div class="work_con clearfix">
        <img src="../../img/triangle.png" alt="" class="triangle">
        <div class="clearfix"  v-if="workData.photo.length">
          <div class="first_work" @click="goDetail(workData.photo[0])">
            <img :src="'https://collection2021-cos.chineseplus.net/'+workData.photo[0].cover" alt="">
          </div>
          <ul class="work_list">
            <li v-for="(v, i) in workData.photo.slice(1)" :key="i" @click="goDetail(v)">
              <img :src="'https://collection2021-cos.chineseplus.net/'+v.cover" alt="">
            </li>
          </ul>
        </div>
        <div class="more" @click="goList(2)">
          查看更多
        </div>
      </div>
    </div>

    <div class="work_wrap">
      <img src="../../img/single_head.png" alt="" class="work_title">
      <div class="work_con clearfix">
        <img src="../../img/triangle.png" alt="" class="triangle">
        <div class="clearfix" v-if="workData.single.length">
          <div class="first_work" @click="goDetail(workData.single[0])">
            <img :src="'https://collection2021-cos.chineseplus.net/'+workData.single[0].cover" alt="">
          </div>
          <ul class="work_list">
            <li v-for="(v, i) in workData.single.slice(1)" :key="i" @click="goDetail(v)">
              <img :src="'https://collection2021-cos.chineseplus.net/'+v.cover" alt="">
            </li>
          </ul>
        </div>
        <div class="more" @click="goList(3)">
          查看更多
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import timeNav from './common/timeNav'

export default {
  components: {
    timeNav
  },
  data () {
    return {
      type: 1,
      yearList: [
        {
          value: '2015年'
        },
        {
          value: '2016年'
        },
        {
          value: '2017年'
        },
        {
          value: '2018年'
        },
        {
          value: '现在'
        }
      ],
      yearIndex: 0,
      workData: {
        video: [],
        photo: [],
        single: []
      }
    }
  },
  created () {
    this.changeYear(this.$route.query.year || 0)
  },
  methods: {
    changeYear (yearIndex) {
      this.yearIndex = yearIndex
      this.$router.push({
        path: this.$route.path,
        query: {
          year: yearIndex
        }
      })
      this.getList()
    },
    goList (type) {
      this.type = type
      this.$router.push({
        path: '/pcpage_history/history_list',
        query: {
          type,
          year: this.yearIndex
        }
      })
    },
    // 获取列表
    getList () {
      let year = this.$route.query.year || 0
      this.$utils.get('/works/history/index', {
        year: this.yearList[year].value.substr(0, 4)
      }).then(res => {
        if(res.code == 1000) {
          this.workData = res.data
        }
      })
    },
    // 去详情
    goDetail (item) {
      let path = ''
      if (item.type == 1) {
        path = '/pcpage_history/vlogdetail'
      } else {
        path = '/pcpage_history/plogdetail'
      }
      this.$router.push({
        path,
        query: {
          id: item.works_id
        }
      })
    },
  },
}
</script>

<style scoped lang="scss">
.history_home {
  width: 1200px;
  height: 100%;
  margin: auto;
  font-size: 24px;
  .nav_con {
    color: #fff;
    font-size: 25px;
    margin-top: 30px;
    .home_tab {
      cursor: pointer;
    }
  }
  .work_wrap {
    margin-bottom: 60px;
    .work_title {
      display: block;
      margin: auto;
      margin-bottom: 50px;
    }
    .work_con {
      background: rgba(255, 255, 255, .8);
      position: relative;
      padding: 40px;
      .triangle {
        position: absolute;
        top: -25px;
        left: 50%;
        margin-left: -25.5px;
      }
      .first_work {
        width: 553px;
	      height: 420px;
        float: left;
        margin-right: 14px;
        cursor: pointer;
        overflow: hidden;
        img {
          display: block;
          width: 100%;
          min-height: 100%;
        }
      }
      .work_list {
        float: right;
        width: calc(100% - 553px - 14px);
        li {
          float: left;
          margin-right: 13px;
          margin-top: 14px;
          width: 270px;
          height: 203px;
          cursor: pointer;
          overflow: hidden;
          &:first-child {
            margin-top: 0;
          }
          &:nth-child(2) {
            margin-top: 0;
          }
          &:nth-child(2n) {
            margin-right: 0;
          }
          img {
            display: block;
            width: 100%;
            min-height: 100%;
          }
        }
      }
      .more {
        font-size: 16px;
        color: #fff;
        text-align: center;
        width: 90px;
	      height: 26px;
        line-height: 26px;
        background-color: #458beb;
	      border-radius: 13px;
        margin: auto;
        margin-top: 25px;
        cursor: pointer;
      }
    }
  }
}
</style>
